<template>
  <esg-table-without-meta :fields="fields"
                          :items="items"
                          :filter="false"
                          max-height="300px"
                          size="sm">
    <template #cell(category)="{item, items, field, row, col, value}">
      <td v-if="item.rowspan && item.rowspan.category">{{ value }}</td>
      <!--  더미 HTML 엘레멘트    -->
      <td v-else
          style="border-top: none"></td>
    </template>
  </esg-table-without-meta>
</template>

<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  name: "SocialDataTable",
  components: {EsgTableWithoutMeta},
  data() {
    return {
      fields: [
        {name: 'category', label: '구분', list: true, type: 'String',},
        {name: 'activity', label: '활동', list: true, type: 'String',},
        {name: '2021', label: '2021', list: true, type: 'Number',},
        {name: '2022', label: '2022', list: true, type: 'Number',},
        {name: '2023', label: '2023', list: true, type: 'Number',},
      ],
      items: [
        {
          category: '주주권리',
          activity: '기업 설명회 개최',
          '2021': 4,
          '2022': 8,
          '2023': 14,
          rowspan: {
            category: 4
          }
        },
        {
          category: '주주권리',
          activity: '전자투표제 도입',
          '2021': '도입',
          '2022': '도입',
          '2023': '도입',
        },
        {
          category: '주주권리',
          activity: '배당정책 공개',
          '2021': '미공개',
          '2022': '공개',
          '2023': '공개',
        },
        {
          category: '주주권리',
          activity: '주총 전 안건 통지',
          '2021': '통지',
          '2022': '통지',
          '2023': '통지',
        },
      ]
    }
  }
}
</script>
